import {assertNotNull, defaultIfNull} from "../util/CommonUtils.js";

export default class StructureIdSearch {
    regio;
    stereo;
    protonation;

    /**
     *
     * @param {string} regio
     * @param {string} [stereo]
     * @param {string} [protonation]
     */
    constructor(regio, stereo, protonation) {
        this.regio = assertNotNull(regio);
        this.stereo = defaultIfNull(stereo, null);
        this.protonation = defaultIfNull(protonation, null);
    }

    /**
     * @param {StructureId} id
     * @param {boolean} withStereo
     * @param {boolean} withProtonation
     * @return StructureIdSearch
     */
    static frommId(id, withStereo, withProtonation) {
        return new StructureIdSearch(id.regio, withStereo ? id.stereo : null, withProtonation ? id.protonation : null);
    }
    /**
     * @param {StructureId[]} ids
     * @param {boolean} withStereo
     * @param {boolean} withProtonation
     * @return StructureIdSearch[]
     */
    static frommIds(ids, withStereo = true, withProtonation = true) {
        const result = [];
        for (const id of ids)
            result.push(this.frommId(id, withStereo, withProtonation));
        return result;
    }
}